import React, { useCallback, useState } from "react";
import TextField, { StandardTextFieldProps } from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import parse from "autosuggest-highlight/parse";

import { CircularProgress, Grid, Typography } from "@material-ui/core";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from "react-places-autocomplete";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        textFieldPlace: {
            marginBottom: theme.spacing(4),
            width: "100%",
        },
        icon: {
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(2),
        },
    })
);

export interface IAutoCompleteAddress {
    handleOnChangeCoordinates?: (lat: number, long: number) => void;
}

const AutoCompleteAddress: React.FC<IAutoCompleteAddress> = ({
    handleOnChangeCoordinates,
}) => {
    const classes = useStyles();
    const [typedAddress, setTypedAddress] = useState("");

    const [openAutoComplete, setOpenAutoComplete] = useState(false);

    const handleChange = useCallback(
        (address) => {
            setTypedAddress(address);
        },
        [setTypedAddress]
    );

    const handleSelect = useCallback(
        (address) => {
            geocodeByAddress(address)
                .then((results) => getLatLng(results[0]))
                .then((latLng) =>
                    handleOnChangeCoordinates(latLng.lat, latLng.lng)
                )
                .catch((error) => console.error("Error", error));
        },
        [setTypedAddress]
    );
    return (
        <PlacesAutocomplete
            onChange={handleChange}
            onSelect={handleSelect}
            value={typedAddress}
        >
            {({
                getInputProps,
                suggestions,
                loading,
                getSuggestionItemProps,
            }) => (
                <div>
                    <Autocomplete
                        fullWidth
                        id="asynchronous-demo"
                        open={openAutoComplete}
                        onOpen={() => {
                            setOpenAutoComplete(true);
                        }}
                        onClose={() => {
                            setOpenAutoComplete(false);
                        }}
                        getOptionLabel={(option) => option.description}
                        options={suggestions.map((suggestions) => suggestions)}
                        loading={loading}
                        renderInput={(params) => {
                            return (
                                <TextField
                                    fullWidth
                                    label={"Procurar"}
                                    variant="standard"
                                    {...params}
                                    onChange={getInputProps().onChange}
                                    onBlur={getInputProps().onBlur}
                                    className={classes.textFieldPlace}
                                />
                            );
                        }}
                        renderOption={(option) => {
                            const parts = parse(
                                option.formattedSuggestion.mainText,
                                option.matchedSubstrings.map((match: any) => [
                                    match.offset,
                                    match.offset + match.length,
                                ])
                            );

                            return (
                                <Grid
                                    container
                                    alignItems="center"
                                    {...getSuggestionItemProps(option)}
                                >
                                    <Grid item>
                                        <LocationOnIcon
                                            className={classes.icon}
                                        />
                                    </Grid>
                                    <Grid item xs>
                                        {parts.map((part, index) => (
                                            <span
                                                key={index}
                                                style={{
                                                    fontWeight: part.highlight
                                                        ? 700
                                                        : 400,
                                                }}
                                            >
                                                {part.text}
                                            </span>
                                        ))}
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            {option.description}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            );
                        }}
                    />
                </div>
            )}
        </PlacesAutocomplete>
    );
};

export default AutoCompleteAddress;
